export default __webpack_public_path__ + "2015 Synchronization of interacting quantum dipoles.pdf";